import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import PollOption from './PollOption';
import localStyles from './PollView.scss';
var PollView = function (_a) {
    var poll = _a.deviation.poll, onVote = _a.onVote, canVote = _a.canVote, className = _a.className, hideQuestion = _a.hideQuestion, draftJsThemeOverride = _a.draftJsThemeOverride, answerClassName = _a.answerClassName, _b = _a.stylesheet, s = _b === void 0 ? localStyles : _b, optionStylesheet = _a.optionStylesheet, optionImageSize = _a.optionImageSize, optionHoverImageSize = _a.optionHoverImageSize;
    var t = useTranslation().t;
    var onClickOption = useCallback(function (answerId) {
        if (!poll) {
            return;
        }
        onVote({ pollId: poll.pollId, userId: poll.user.userId, answerId: answerId });
    }, [onVote, poll]);
    if (!poll) {
        return null;
    }
    return (React.createElement(BiLoggerContextProvider, { value: { pollid: poll.pollId } },
        React.createElement("div", { className: classnames(s['root'], className) },
            !hideQuestion && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: s['question'] }, poll.question),
                React.createElement("div", { className: s['info'] },
                    React.createElement("span", { className: s['votes'] }, t('pollView.votes', { count: poll.votes }))))),
            poll.answers.map(function (answer) { return (React.createElement(PollOption, { key: answer.answerId, className: s['poll-option'], answer: answer, canVote: canVote, onClick: onClickOption, draftJsThemeOverride: draftJsThemeOverride, answerClassName: answerClassName, stylesheet: optionStylesheet, imageSize: optionImageSize, hoverImageSize: optionHoverImageSize })); }))));
};
PollView.displayName = 'PollView';
export default PollView;
//# sourceMappingURL=PollView.js.map